import { render, staticRenderFns } from "./ForgotPassword-v1.vue?vue&type=template&id=6291e56e"
import script from "./ForgotPassword-v1.vue?vue&type=script&lang=js"
export * from "./ForgotPassword-v1.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword-v1.vue?vue&type=style&index=0&id=6291e56e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports